import { render } from "./InputTags.vue?vue&type=template&id=3d27f031&scoped=true"
import script from "./InputTags.vue?vue&type=script&lang=js"
export * from "./InputTags.vue?vue&type=script&lang=js"

import "./InputTags.vue?vue&type=style&index=0&id=3d27f031&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d27f031"]])

export default __exports__